import { FormGroup, AbstractControl } from "@angular/forms";

interface ValidationResult {
  [key: string]: boolean;
}

export class CustomValidators {


  static email(control: FormGroup): ValidationResult {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z\-0-9]{1,}))$/;
    if (control.value != "" && re.test(control.value)) {
      return null;
    }

    return { "email": true };
  }
  static validateUsDate(control: FormGroup): ValidationResult {
    let usDatePattern = /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20|21)\d{2}$/;

    if (!control.value.match(usDatePattern))
      return { "usDate": true };

    return null;
  }
  static validatePassword(control: FormGroup): ValidationResult {
    let pattern = /^.*(?=.{8,})((?=.*[!#*$%\-_=+{};:,<.>]){1})(?=.*\d)((?=.*[a-z]){1})((?=.*[A-Z]){1}).*$/;
  
    if (!pattern.test(control.value))
      return { "isValidPassword": true };

      
    return null;
  }
  static matchingPasswords(passwordKey: string, confirmPasswordKey: string) {
    return (group: FormGroup): { [key: string]: any } => {
      let password = group.controls[passwordKey];
      let confirmPassword = group.controls[confirmPasswordKey];
      if (password.value !== confirmPassword.value) {
        return {
          matchingPasswords: true
        };
      }
    }
  }

  //static nospaceValidator(control: AbstractControl): { [s: string]: boolean } {
  static nospaceValidator(control: FormGroup): ValidationResult {
    let re = /\s+/;
    let notRe = /\s*\S+/;
    if (control.value && control.value.match(re) && !control.value.match(notRe)) {
      return { "nospace": true };
    }
    return null;
  }

}